import { render } from "./Show.vue?vue&type=template&id=6f60816e&scoped=true&lang=pug"
import script from "./Show.vue?vue&type=script&lang=ts"
export * from "./Show.vue?vue&type=script&lang=ts"

import "./Show.vue?vue&type=style&index=0&id=6f60816e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6f60816e"

export default script